import { createStore } from 'vuex'
import holiday from './modules/holiday'
import shippingBanner from './modules/shippingBanner'

export default createStore({
    state: {
        user: null,
        isAuthenticated: false,
        cart: []
    },
    getters: {
        isAdmin(state) {
            return state.user && state.user.role === 'ROLE_ADMIN'
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user
            state.isAuthenticated = !!user
        },
        addToCart(state, item) {
            state.cart.push(item)
        }
    },
    actions: {
        login({ commit }, user) {
            commit('setUser', user)
        },
        logout({ commit }) {
            commit('setUser', null)
        }
    },
    modules: {
        holiday,
        shippingBanner
    }
})